import theme from 'clad-ui/theme/chotot';
import { styled } from 'linaria/react';
export const RewardWrapper = /*#__PURE__*/styled("div")({
  name: "RewardWrapper",
  class: "r1o1bbkb"
});
export const CloseButton = /*#__PURE__*/styled("div")({
  name: "CloseButton",
  class: "c15cr4p7"
});

require("../../../.linaria-cache/src/components/JobFloatingButton/styled.linaria.module.css");